export default __webpack_public_path__ + "static/media/KEL.f36352b7.png";